import { isString } from "@ciaopeople/cp-shatsu/TypeChecking";

enum AuthProviderIdentifier  {

    FACEBOOK = "fb",
    GOOGLE = "goo",
    GOOGLE_ONE_TAP = "got",
    APPLE = "app",
    FIREBASE = "fbase",
    FIRST_PARTY_EMAIL = "eml1pt"
    
}

function firebaseIdToAuthProvId (str: string): AuthProviderIdentifier|null {
    if (!isString(str)) return null;
    const lowered = str.toLowerCase();
    if(lowered.includes("google")) return AuthProviderIdentifier.GOOGLE;
    else if (lowered.includes("facebook")) return AuthProviderIdentifier.FACEBOOK;
    else if (lowered.includes("apple")) return AuthProviderIdentifier.APPLE;
    else if (lowered.includes("email")) return AuthProviderIdentifier.FIRST_PARTY_EMAIL;
    else return null;
}

function authProviderIdNiceName(a: AuthProviderIdentifier): string {
    if(a == AuthProviderIdentifier.FACEBOOK) return "Facebook";
    else if (a == AuthProviderIdentifier.FIREBASE) return "Firebase";
    else if (a == AuthProviderIdentifier.GOOGLE) return "Google";
    else if (a == AuthProviderIdentifier.GOOGLE_ONE_TAP) return "Google (one-tap)";
    else if (a == AuthProviderIdentifier.APPLE) return "Apple";
    else if (a == AuthProviderIdentifier.FIRST_PARTY_EMAIL) return "Email";
    else return "";
}

export { AuthProviderIdentifier, firebaseIdToAuthProvId, authProviderIdNiceName};